export const DRAWER_TYPE = {
	edit_profile: 'edit_profile',
	change_password: 'change_password',
}

export const MATCHING_PERCENTAGE = {
	MIN: 20,
	MAX: 100,
}
